import React, {useState, useEffect} from 'react';
import {Row, Col} from "reactstrap";
import ApiService from "../../util/ApiService";
import Swal from "sweetalert2";
import Modal from 'react-bootstrap/Modal';
import {Form} from 'react-bootstrap';
import { Tooltip } from 'antd';
import LoadingScreen from "../../util/LoadingScreen";
import Switch from "react-switch";
import ReactQuill from "react-quill";
import AuthService from "../../login/AuthService";
import {format, parseISO} from "date-fns";
import {ptBR} from "date-fns/locale";


const PreferencesCompanyConfigAccreditationNotification = () => {
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [formData, setFormData] = useState({
        date_notification: "",
        email: "",
        accreditation_expired_duty: 0
    });

    useEffect(() => {
        fetchListCompanyAssistant();
    }, []);

    const fetchListCompanyAssistant = async () => {

        try {
            setLoading(true);
            const companyId = AuthService.getCompanyId();
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}users/list-assistant`,
                {id: companyId},
                true
            );

            const {data} = ApiService.handleApiResponse(response);


            setFormData(data);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        setLoadingSave(true);
        try {
            let response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}users/company-assistant-notification`,
                formData,
                true
            );

            Swal.fire("Sucesso", "Configuração salva com sucesso!", "success").then(() => {

            });

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSave(false); // Finaliza o carregamento
        }
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    return (
        <>
            {loading && <LoadingScreen/>}
            <Row>
                <Form>
                    <div className="row">

                        <div className="col-12r row">
                            <div className="col-4  mb-1">
                                <label className="form-label me-2">
                                    Notificar em (Dias)
                                    <Tooltip title="Informe com quantos dias de antecedência o usuário deverá ser notificado por e-mail sobre o vencimento do credenciamento.">
                                        <i className="fa fa-info-circle ms-2 text-primary" />
                                    </Tooltip>
                                </label>
                                <input
                                    type="number"
                                    className="form-control mt-2 me-6"
                                    value={formData.date_notification || ''}
                                    name="date_notification"
                                    onChange={handleInputChange}

                                />
                            </div>
                            <div className="col-6  mb-1">
                                <label className="form-label "  >Usuário Vencido? (Cancelar Escala/Plantão)</label>
                                <Switch
                                    checked={formData.accreditation_expired_duty === 1}
                                    onChange={(checked) => setFormData({
                                        ...formData,
                                        accreditation_expired_duty: checked ? 1 : 0
                                    })}
                                    onColor="#0d6efd"
                                    offColor="#ccc"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    title="Selecionar automaticamente o primeiro plantonista que se candidatar ao plantão"
                                    className="react-switch mt-2"
                                />
                                <span>{formData.accreditation_expired_duty === 1 ? "Sim" : "Não"}</span>
                            </div>
                        </div>
                        <div className="form-group col-12 mt-3">
                            <label>Mensagem para o credenciado</label>
                            <ReactQuill
                                theme="snow"
                                value={formData.email || ""}
                                onChange={(content) => setFormData({...formData, email: content})}
                                placeholder="Digite o texto da mensagem..."
                                className="custom-quill mb-5"
                                modules={{
                                    toolbar: [
                                        [{header: [1, 2, false]}],
                                        ["bold", "italic", "underline"],
                                        [{list: "ordered"}, {list: "bullet"}],
                                        ["link"],
                                        ["clean"]
                                    ],
                                }}
                                formats={[
                                    "header", "bold", "italic", "underline",
                                    "list", "bullet", "link", "image"
                                ]}
                            />
                        </div>
                    </div>
                </Form>
                <Row className="mt-4">
                    <Col>
                        <button type="button" className="btn btn-primary" onClick={() => handleSave()}
                                disabled={loadingSave}>
                            {loadingSave ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Salvando...
                                </>
                            ) : (
                                <>
                                    <i className={`fa  fa-save me-2`}></i>
                                    Salvar
                                </>
                            )}
                        </button>
                    </Col>
                </Row>
            </Row>
        </>

    );
};


export default PreferencesCompanyConfigAccreditationNotification;
